import taskTemplateModel from '../../../../models/task-management/task-template.model';
import languageModel from '../../../../models/language.model';
import { Dialog } from 'construct-ui';
import paginationComponent from '../../../../components/pagination/pagination.component';
import ViewBase from '../../../view-base.view';
import { messageComponent } from '../../../../components/message/message.component';
import TaskTemplateAddView from './task-template-create.view';
import SelectUserComponent from '../../../../components/user/select-user.component';
import MultiSelectComponent from '../../../../components/multi-select/multi-select.component';
import SelectSiteGroupComponent from '../../../../components/site/select-site-group.component';
import SelectSiteComponent from '../../../../components/site/select-site.component';
import userSearchModal from '../../../../models/common/user-search.modal';
import SingleSelectComponent from '../../../../components/single-select/single-select.component';

export default function TaskTemplateView() {
  ViewBase.call(this);

  let inputDataModel = {
    masterId: 0,
    data: [],
    pageIndex: 1,
    pageSize: 10,
    totalSize: 0,
    templateName: "",
    selectedPermissions: [],
    selectedUsers: [],
    selectedUserRoles: [],
    selectedSites: [],
    selectedSiteGroups: [],
    selectedBcpTemplate: { code: "" }
  };

  let bcpTemplates = [
    { code: "0", name: "No" },
    { code: "1", name: "Yes" },
  ]
  let userID = 0;
  let isMsgOpen = false;
  let isAddViewOpen = false;
  let isBcpOptionsEnabled = false;
  let showMsg = "";
  let msgTitle = "";
  let userRoles = [];
  let permissions = [
    { code: "001", name: "Public" },
    { code: "002", name: "Personal" }];

  let _getUserRoles = () => {
    userRoles = [];
    return userSearchModal.getUserRoleList(
      (result) => {
        userRoles = result;
      },
      (error) => {
        this.handleError(error);
      }
    )
  }

  let _getTemplateName = (e) => {
    inputDataModel.templateName = e.target.value;
  }

  let _clearFilter = () => {
    inputDataModel.templateName = "";
    inputDataModel.selectedPermissions = [];
    inputDataModel.selectedUserRoles = [];
    inputDataModel.selectedSites = [];
    inputDataModel.selectedSiteGroups = [];
    inputDataModel.selectedUsers = [];
    inputDataModel.selectedUserRole = [];
    _initControls();
  }

  let _search = () => {
    inputDataModel.pageIndex = 1;
    _loadTaskTemplateList();
  }

  let _loadBcpTemplateOptions = () => {
    this.showLoading();
    taskTemplateModel.getTemplateBCPOptions()
      .then((r) => {
        if (r && Array.isArray(r) && r.length > 0) {
          isBcpOptionsEnabled = true;
        }
      }).catch(e => {

        this.handleError(e);
      }).finally(() => {
        this.hideLoading();
      })
  }

  let _loadTaskTemplateList = () => {
    this.showLoading();

    return taskTemplateModel.getTaskTemplateList(inputDataModel)
      .then((result) => {
        inputDataModel.data = result.data;
        inputDataModel.totalCount = result.total;
        inputDataModel.pageIndex = result.pageIndex;
        inputDataModel.pageSize = result.pageSize;
      })
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => { this.hideLoading() });
  }

  let _initControls = () => {
    _loadBcpTemplateOptions();
    _loadTaskTemplateList();
    _getUserRoles();
  }

  let onPageSizeChanged = (pageIndex, pageSize) => {
    inputDataModel.pageIndex = pageIndex;
    inputDataModel.pageSize = pageSize;
    _loadTaskTemplateList();
  }

  let onPageChanged = (pageIndex) => {
    inputDataModel.pageIndex = pageIndex;
    _loadTaskTemplateList();
  }

  function _loadDetailsView(item) {
    userID = item.updateUserId;
    inputDataModel.masterId = item.taskTemplateMstId;
    isAddViewOpen = true;
  }

  let _register = () => {
    inputDataModel.masterId = 0;
    isAddViewOpen = true;
  }

  let _dialogClosed = () => {
    isMsgOpen = false;
  }


  let _addClose = () => {
    inputDataModel.masterId = 0;
    isAddViewOpen = false;
  }

  let _onSaveComplete = (result) => {
    inputDataModel.masterId = 0;
    isMsgOpen = true;
    showMsg = result[0].transStatus;
    msgTitle = this.getText(result[0].code, result[0].message);
    _loadTaskTemplateList();
    isAddViewOpen = false;
  }

  let getParameterByName = (name, url = window.location.href) => {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  return {
    oninit: (vnode) => {
      _initControls();
    },
    oncreate: (vnode) => {
      let ref = getParameterByName("ref");
      if (ref == "task-master") {
        _register();
      }
    },
    view: (vnode) => {
      return [
        m('.row',
          m('.col-12',

            // Title section
            m('.d-flex.justify-content-end.align-items-end.mb-3',
              m('button.btn.btn-outline-primary.btn-add.mb-2',
                { onclick: _register }, [
                m("i.bi.bi-plus-lg.me-0"),
              ]),
            ),

            // Search section
            m('.card.mb-3',
              m('.card-body',
                m('.row.g-4',
                  m('.col-md-4.col-lg-4',
                    m('label.form-label', languageModel.getText("LT00000300", "Template Name")),
                    m('input[type=text][placeholder=' + languageModel.getText("LT00000300", "Template Name") + '][value="' + inputDataModel.templateName + '"].form-control.form-control-bg', { onchange: _getTemplateName })
                  ),
                  m('.col-md-4.col-lg-4',
                    m('label.form-label', this.getText("LT00000079", "Permission")),
                    m(MultiSelectComponent, {
                      items: permissions,
                      selectedItems: inputDataModel.selectedPermissions,
                      onSelect: (selectedList) => {
                        inputDataModel.selectedPermissions = selectedList;
                      }
                    })
                  ),
                  m('.col-md-4.col-lg-4',
                    m('label.form-label', this.getText("LT00000219", "Users")),
                    m(SelectUserComponent, {
                      default: {
                        userStatusCode: '0001'
                      },
                      onSelect: (u) => {
                        inputDataModel.selectedUsers = u;
                      },
                      selectedUserList: inputDataModel.selectedUsers,
                    })
                  ),
                  m('.col-md-4.col-lg-4',
                    m('label.form-label', this.getText("LT00000060", "User Role")),
                    m(MultiSelectComponent, {
                      items: userRoles,
                      selectedItems: inputDataModel.selectedUserRoles,
                      onSelect: (u) => {
                        inputDataModel.selectedUserRoles = u;
                      }
                    })
                  ),
                  m('.col-md-4.col-lg-4',
                    m('label.form-label', this.getText("LT00000071", "Site")),
                    m(SelectSiteComponent, {
                      selectedItemList: inputDataModel.selectedSites,
                      onChange: (s) => {
                        inputDataModel.selectedSites = s;
                      }
                    })
                  ),
                  m('.col-md-4.col-lg-4',
                    m('label.form-label', this.getText("LT00000072", "Site Group")),
                    m(SelectSiteGroupComponent, {
                      selectedItems: inputDataModel.selectedSiteGroups,
                      onChange: (g) => {
                        inputDataModel.selectedSiteGroups = g;
                      }
                    })
                  ),
                  isBcpOptionsEnabled &&
                  m('.col-md-4.col-lg-4',
                    m('label.form-label', this.getText("LT00001199", "BCP Template")),
                    m(SingleSelectComponent, {
                      items: bcpTemplates,
                      selectedItem: inputDataModel.selectedBcpTemplate,
                      onSelect: (s) => { inputDataModel.selectedBcpTemplate = s; },
                    }),
                  ),
                  m('.col-12.gap-2.d-flex.justify-content-end',
                    m('button.btn.btn-primary', { onclick: _search }, languageModel.getText("LT00000001", "Search")),
                    m('button.btn.btn-white', { onclick: _clearFilter }, languageModel.getText("LT00000031", "Clear")),
                  ),
                )
              )
            ),

            // Table section
            m('.card',
              m('.card-body',
                m('.row',
                  m(".col-12.p-0",
                    m(".table-responsive",
                      m("table.table",
                        [
                          m("thead.thead-bggrey",
                            m("tr.align-middle",
                              [
                                m("th", { "scope": "col" }, languageModel.getText("LT00000279", "Task Template Name")),
                                m("th", { "scope": "col" }, languageModel.getText("LT00000012", "Description")),
                                m("th", { "scope": "col" }, languageModel.getText("LT00000301", "Start Date")),
                                m("th", { "scope": "col" }, languageModel.getText("LT00000302", "End Date")),
                                m("th", { "scope": "col" }, languageModel.getText("LT00000303", "No. of tasks")),
                                m("th", { "scope": "col" }, languageModel.getText("LT00000304", "No. of assigned employees")),
                                m("th", { "scope": "col" }, languageModel.getText("LT00000079", "Permission")),
                                m("th", { "scope": "col" }, languageModel.getText("LT00001199", "BCP Template")),
                                m("th", { "scope": "col" }, languageModel.getText("LT00000305", "Update User")),
                                m("th", { "scope": "col" }, languageModel.getText("LT00000306", "Update Date"))
                              ])
                          ),
                          m("tbody",
                            inputDataModel.data.length == 0 &&
                            m("tr", { "class": "align-middle" },
                              m("td", { "colspan": "9" }, languageModel.getText("EM00000141", "No records found."))
                            ),
                            inputDataModel.data.map(gc =>{
                              return[
                                m("tr",
                                  [
                                    m("td.anchorButton", { onclick: () => { _loadDetailsView(gc) } }, gc.taskTemplateName),
                                    m("td", gc.description),
                                    m("td", gc.startDate),
                                    m("td", gc.endDate),
                                    m("td", gc.noOfTaskAssigned),
                                    m("td", gc.noOfUserAssigned),
                                    m("td", gc.permission.trim() == '001' && m('span.bullet-blue', m('i.bi.bi-circle-fill'), gc.permissionName),
                                      gc.permission.trim() == '002' && m('span.bullet-yellow', m('i.bi.bi-circle-fill'), gc.permissionName)),
                                    m("td.text-center", m('input.form-check-input[type="checkbox"][disabled]',{
                                      checked: gc.isBCPTemplate
                                    })
                                    ),
                                    m("td", gc.updateUserId),
                                    m("td", gc.updateDate)
                                  ])
                              ]}),
                          )
                        ])
                    ),
                    !this.isLoading && m(".px-3",
                      m(paginationComponent, { currentPage: inputDataModel.pageIndex, pageSize: inputDataModel.pageSize, totalItems: inputDataModel.totalCount, onPageChanged: onPageChanged, onPageSizeChanged: onPageSizeChanged })
                    )
                  )
                )
              )
            )
          ),
          isAddViewOpen && m(Dialog, {
            isOpen: isAddViewOpen,
            transitionDuration: 200,
            closeOnOutsideClick: false,
            onClose: () => { isAddViewOpen = false; inputDataModel.masterId = 0; },
            title: inputDataModel.masterId === 0 ? this.getText("LT00000123", "Task Template Create") : this.getText("LT00000122", "Task Template Update"),
            content: m(TaskTemplateAddView, { onAddClose: _addClose, onSaveComplete: _onSaveComplete, masterId: inputDataModel.masterId, userID: userID }),
            "class": "cui-dialog-l",
            style: {"min-width": '880px'}
          }),
          m(messageComponent, { isOpen: isMsgOpen, message: showMsg, title: msgTitle, onClosed: _dialogClosed })
        ),
        this.getBaseViews()
      ]
    }
  }
}
